import React, { useEffect } from 'react';

interface ToastNotificationProps {
  toastMsg: string | null;
  setToastMsg: (msg: string | null) => void;
  autoHide?: boolean; // New prop to control auto-hide behavior
  duration?: number; // New prop to control duration in milliseconds
}

const ToastNotification: React.FC<ToastNotificationProps> = ({
  toastMsg,
  setToastMsg,
  autoHide = true, // Default to true
  duration = 5000, // Default to 5 seconds
}) => {
  useEffect(() => {
    if (toastMsg && autoHide) {
      const timer = setTimeout(() => {
        setToastMsg(null);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [toastMsg, autoHide, duration, setToastMsg]);

  if (!toastMsg) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50 bg-white border border-slate-200 rounded-lg shadow-lg p-4 max-w-sm animate-fade-in-out">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0">
          <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium text-slate-900">{toastMsg}</p>
        </div>
        <button 
          className="flex-shrink-0 text-slate-400 hover:text-slate-600 transition-colors"
          onClick={() => setToastMsg(null)}
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ToastNotification; 